<template>
  <div class="page-container">
    <Filter :params="params" @search="searchData"></Filter>
    <Table :tableData="tableDataList" :total="total" @update="updatePage">
      <el-table-column type="index" align="center" :label="$t('pages.indexNo')" width="60px" />
      <el-table-column prop="createTime" :label="$t('activity.list.createTime')" width="150" />
      <el-table-column prop="updateTime" :label="$t('activity.wxacode.modifyTime')" width="150" />
      <el-table-column prop="creator" :label="$t('activity.list.creator')" />
      <el-table-column prop="type" :label="$t('activity.list.actType')" />
      <el-table-column prop="activityName" :label="$t('activity.list.actName')" />
      <el-table-column prop="startDate" :label="$t('activity.detail.startTime')" width="150" />
      <el-table-column prop="endDate" :label="$t('activity.detail.endTime')" width="150" />
      <el-table-column :label="$t('activity.list.qrCode')" >
        <template #default="{row}">
          <el-button type="text" size="small" @click="downloadWXAcode(row)">{{ $t('activity.list.download') }}</el-button>
        </template>
      </el-table-column>
      <el-table-column prop="customerName" :label="$t('activity.signin.customerName')" />
    </Table>
  </div>
</template>

<script>
import { reactive, toRefs } from "@vue/reactivity";
// import { ElMessage } from "element-plus";

import Table from "@/components/table/index";
import Filter from "@/components/table/filter";
import useActivity from './useActivity';

import { request } from "@/utils/request";
import { common } from "@/common/mixin";
import { useI18n } from 'vue-i18n'
export default {
  components: {
    Table,
    Filter,
  },
  mixins: [common],
  setup() {
    const { t } = useI18n()
    const { activityTypeList } = useActivity()
    const state = reactive({
      params: [
        {
          type: "Input",
          key: "activityName",
          value: "",
          label: t('activity.list.actName'),
        },    
        {
          type: "Select",
          key: "type",
          value: "",
          label: t('activity.list.actType'),
          options: {
            data: activityTypeList,
            label: "translatedValue",
            value: "value"
          }
        },
        {
          type: "Input",
          key: "customerName",
          value: "",
          label: t('activity.signin.customerName'),
        },
        {
          type: "Date",
          key: "dateRange",
          value: [],
          label: t('activity.list.date'),
          options: {
            "type": "daterange",
            "format": "YYYY-MM-DD",
            "value-format": "YYYY-MM-DD",
            "range-separator": t('activity.detail.to'),
            "start-placeholder": t('activity.list.startDate'),
            "end-placeholder": t('activity.list.endDate')
          }
        },
      ],
      query: {},
      page: 1,
      size: 10,
      total: 0,
      dialogFormVisible: false,
      tableDataList: [],
      activityType: activityTypeList // 活动类型列表
    })
    const getData = async () => {
      try {
        const res = await request("unionActivityList", {
          ...state.query,
          page: state.page,
          size: state.size,
        });
        state.tableDataList = res.records;
        state.total = res.total;
      } catch (error) {
        console.error(error);
      }
    }
    const searchData = async (data) => {
      state.query = data
      if (data.dateRange && data.dateRange.length>0) {
        state.query.startDate = data.dateRange[0]
        state.query.endDate = data.dateRange[1]
      } else {
        state.query.startDate = ''
        state.query.endDate = ''
      }
      getData()
    }
    const updatePage = (page, size) => {
      state.page = page || 1
      state.size = size || 10
      getData()
    }
    const downloadWXAcode = (row) => {
      let a = document.createElement('a')
      a.download = row.activityName + '-' + row.customerName
      a.href = 'data:image/jpeg;base64,' + row.qrCode
      a.click();
    }
    getData();
    return {
      ...toRefs(state),
      getData,
      searchData,
      updatePage,
      downloadWXAcode
    }
  }
}
</script>

<style lang="scss" scoped>
.page-container {
  height: 100%;
  padding: 50px 10px 0;
  box-sizing: border-box;
  display: flex;
  flex-direction: column;
}
</style>
